// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../assets/images/tabs_bcg.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1wE8QEeDLZUNf9rCTHgNFM{height:100%;display:flex;flex-direction:column}.J7nx6_W11Dkmsi6ccIlbI{display:flex;align-items:flex-end}._1FlHlo3T9rpK-jJVThpaxJ{font-size:.92857rem;font-weight:700;background:#fff;opacity:0.5;cursor:pointer;padding:.35714rem .14286rem;margin:0 .07143rem;display:flex;flex:1;justify-content:center}._2nADzWGnkYD5oiUxFYS2Ei{opacity:1;padding:.5rem .57143rem;margin:0}._1Su1_lbOldLHpkHj2VyR-x{height:100%;background-color:#fff;padding:.28571rem}._3n76Z0H44zA_e1_RGu-ic6{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");height:100%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "_1wE8QEeDLZUNf9rCTHgNFM",
	"tabs__buttonWrapper": "J7nx6_W11Dkmsi6ccIlbI",
	"tabs__button": "_1FlHlo3T9rpK-jJVThpaxJ",
	"tabs__button_active": "_2nADzWGnkYD5oiUxFYS2Ei",
	"tabs__contentWrapper": "_1Su1_lbOldLHpkHj2VyR-x",
	"tabs__content": "_3n76Z0H44zA_e1_RGu-ic6"
};
export default ___CSS_LOADER_EXPORT___;
